import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { Router } from '@angular/router';
import { AccountSourcesRoutingModule } from '../../dashboard/account-sources/account-sources-routing.module';

@Component({
  selector: 'app-side-bar-component',
  imports: [
    MatIconModule,
    MatButtonModule,
    MatListModule,
    AccountSourcesRoutingModule,
    MatListModule,
  ],
  templateUrl: './side-bar-component.html',
  styleUrl: './side-bar-component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideBarComponent {
  #router = inject(Router);

  async goToHome() {
    await this.#router.navigateByUrl('/');
  }
}
